(() => {
  const sections = document.querySelectorAll('[data-ah]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const revealItems = section.querySelectorAll('[data-ah-reveal]');

    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });

    revealItems.forEach((item) => observer.observe(item));
  });
})();
